
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <center>
  When ordering a commission from me, you are automatically agreeing to follow
  my terms of service. Failure to comply with the terms of service will ensure
  that you are <b>blacklisted</b> from future commission slots, YCHs, raffles,
  adoptables, events, and any future events held.
    </center>
    <hr></hr>
    <p>{`Please note that I will only start your commission once I have received payment
in full. I also offer payment plans.`}<br /></p>
    <p>{`All prices are in USD, I accept PayPal payments only.`}</p>
    <h3>{`Please note:`}</h3>
    <ul>
      <li parentName="ul">{`I do not accept PayPal commissions from customers under 18.`}</li>
      <li parentName="ul">{`I do not accept NSFW commissions from customers under 18, I require I.D. with proof of your age.`}</li>
      <li parentName="ul">{`When ordering a commission from me you must make payment(s) using your own PayPal account.`}</li>
      <li parentName="ul">{`I will only accept PayPal payment(s) from customers via invoice. I do not accept payments through the "friends and family" option unless you are a trusted, regular customer.`}</li>
      <li parentName="ul">{`I will only accept and discuss commission details via email, unless you are a trusted customer.`}</li>
      <li parentName="ul">{`Requiring significant or multiple modifications for a commission may attract
additional costs.`}</li>
      <li parentName="ul">{`I reserve the right to decline commissions for any reason.`}</li>
      <li parentName="ul">{`I reserve the right to place my watermark on any artwork I produce.`}</li>
      <li parentName="ul">{`Unless explicitly agreed upon `}<strong parentName="li">{`and paid for`}</strong>{` I retain the legal copyrights to my
original work. You may not reproduce or sell my artwork without prior
permission.`}</li>
      <li parentName="ul">{`I strive to ensure that all customers are 100% satisfied with their
commission(s).`}</li>
      <li parentName="ul">{`I offer private commissions* for those who do not wish for their commission to
be uploaded publicly.`}</li>
    </ul>
    <p><strong parentName="p">{`Please note:`}</strong>{` Each commission is completed by me alone. Due to high demand
there are wait times of 2-3 weeks. I offer high priority commissions** for
customers who require their commission urgently. You may ask for updates for
work in progress. Please be respectful.`}</p>
    <p>{`I have a zero tolerance policy regarding harassment. People who cannot respect
this may have their commissions sent 'As Is' without refund and further requests
will be refused. Unless your project has not been started 28 days or more after
payment was received, all commissions are non-refundable.`}</p>
    <ul>
      <li parentName="ul">{`You may upload my artwork to approved social media sites if you have credited
me properly and provide a link to my social media or website.`}</li>
      <li parentName="ul">{`You may not repost my artwork to any online gallery that does not immediately
credit me as the original artist. (such as DeviantART, FurAffinity, etc.)`}</li>
      <li parentName="ul">{`I do not, under any circumstances give anyone permission to trace, recolor,
alter or make bases from my artwork. Do not claim my artwork as your own and try
to make profit from it.`}</li>
    </ul>
    <p>{`If you would like a print, mug, bag, etc of your completed commission please let
me know and I will privately add it to my TeePublic/Redbubble store for you to
purchase.`}</p>
    <hr></hr>
    <p>{`*) If you would like your commission to be kept private (sent directly to you
and not uploaded anywhere) I require an additional 50% of the total commission
cost as a privacy fee.`}</p>
    <p>{`**) High priority commissions are considered most important and take superiority
over all current commissions, to be dealt with expeditiously. High Priority
commissions cost $50 USD per piece which will to be added to the total cost of
the commission. High priority commissions have a turnaround time of 12-48 hours.
Please note that on extremely rare occasions (days/nights when I am out of town) I may have to deny or ask for more time.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;